import CoursePage from './CoursePage';
import useEvents from '../../hooks/useEvents';

export default function TanzabendPage() {
  const { events, loading } = useEvents('tanzabend');
  return (
    <CoursePage courses={events} loading={loading} pageTitle={'Tanzabend'} category={'tanzabend'} />
  );
}
